require('./gameLoader.js');
require('./game.js');
require('./helperFunctions.js');
require('./gameController.js');
require('./spinController.js');
require('./ui/settingsMenu.js');
require('./ui/BPsettingsMenuButton.js');
require('./freespins.js');
require('./pixi-spine.js');
require('../../libs/reflex-library/src/lib/spine.js');
require('./particleManager.js');
require('./winlineAnimator.js');
require('./BPwinlineAnimationController.js');
require('./colourBox.js');
require('./screenDimObject.js');
require('./bigWin.js');
require('../../node_modules/hammerjs/hammer.min.js');
require('./decreaseStakeButton.js');
require('./increaseStakeButton.js');
require('./hbcVolumeButton.js');
require('./ui/gameStakeSelection.js');
require('./ui/BPautoplayManager-ext.js');
require('./ui/BPgameHistoryButton.js');
require('./ui/sideMenu.js');
require('./ui/BPsideMenuButton.js');
require('./ui/settingTotalBet.js');
require('./ui/settingSound.js');
require('./ui/BPgameRulesStringButton.js');
require('./ui/BPfullscreenButton.js');
require('./mushroomsRecoveryController.js');
require('./ReelSpinnerVisualSCS.js');
require('./shuffle.js');
require('./winAnimations/WinBatcherGroupedSymbols.js');
require('./winAnimations/WinController.js');
require('./shaker.js');
require('./ui/buyBonusButton.js');
require('./ui/buyBonusPopup.js');
require('./ui/skipWinsButton.js');
require('./ui/BPoptionsButtonEx.js');
require('./multiplierTrail.js');
require('./SymbolAnimator.js');
require('./ui/goldenBetToggle.js');
require('../../libs/reflex-library/src/lib/gsap.min.js');
require('../../libs/reflex-library/src/lib/gsapPixiPlugin.js');
require('./WinTextController.js');
require('./ScrollContainer.js');
require('./musicManager.js');
require('./SoundManager.js');
require('./orbDisplay.js');
require('./xtraPowerSideText.js');
require('./powerBarDisplay.js');
require('./overlayDisplay');
require('./logoPopupDisplay.js');
require('./backgroundLightningDisplay.js');
require('./messageBar.js');
require('./winlineDisplay.js');
require('./symBackgroundAnimDisplay.js');
require('./utils.js');
